"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useGridDetailPanel = exports.detailPanelStateInitializer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _xDataGrid = require("@mui/x-data-grid");
var _internals = require("@mui/x-data-grid/internals");
var _gridDetailPanelToggleColDef = require("./gridDetailPanelToggleColDef");
var _gridDetailPanelSelector = require("./gridDetailPanelSelector");
var detailPanelStateInitializer = function(state, props) {
    var _props_initialState_detailPanel, _props_initialState;
    var _props_detailPanelExpandedRowIds, _ref;
    return (0, _extends2.default)({}, state, {
        detailPanel: {
            heightCache: {},
            expandedRowIds: (_ref = (_props_detailPanelExpandedRowIds = props.detailPanelExpandedRowIds) !== null && _props_detailPanelExpandedRowIds !== void 0 ? _props_detailPanelExpandedRowIds : (_props_initialState = props.initialState) === null || _props_initialState === void 0 ? void 0 : (_props_initialState_detailPanel = _props_initialState.detailPanel) === null || _props_initialState_detailPanel === void 0 ? void 0 : _props_initialState_detailPanel.expandedRowIds) !== null && _ref !== void 0 ? _ref : []
        }
    });
};
exports.detailPanelStateInitializer = detailPanelStateInitializer;
function cacheContentAndHeight(apiRef, getDetailPanelContent, getDetailPanelHeight, previousHeightCache) {
    if (typeof getDetailPanelContent !== 'function') {
        return {};
    }
    // TODO change to lazy approach using a Proxy
    // only call getDetailPanelContent when asked for an id
    var rowIds = (0, _xDataGrid.gridDataRowIdsSelector)(apiRef);
    var contentCache = rowIds.reduce(function(acc, id) {
        var params = apiRef.current.getRowParams(id);
        acc[id] = getDetailPanelContent(params);
        return acc;
    }, {});
    var heightCache = rowIds.reduce(function(acc, id) {
        var _previousHeightCache_id;
        if (contentCache[id] == null) {
            return acc;
        }
        var params = apiRef.current.getRowParams(id);
        var height = getDetailPanelHeight(params);
        var autoHeight = height === 'auto';
        acc[id] = {
            autoHeight: autoHeight,
            height: autoHeight ? (_previousHeightCache_id = previousHeightCache[id]) === null || _previousHeightCache_id === void 0 ? void 0 : _previousHeightCache_id.height : height
        };
        return acc;
    }, {});
    return {
        contentCache: contentCache,
        heightCache: heightCache
    };
}
var useGridDetailPanel = function(apiRef, props) {
    var contentCache = (0, _xDataGrid.useGridSelector)(apiRef, _gridDetailPanelSelector.gridDetailPanelExpandedRowsContentCacheSelector);
    var handleCellClick = React.useCallback(function(params, event) {
        if (params.field !== _gridDetailPanelToggleColDef.GRID_DETAIL_PANEL_TOGGLE_FIELD || props.getDetailPanelContent == null) {
            return;
        }
        var content = contentCache[params.id];
        if (!/*#__PURE__*/ React.isValidElement(content)) {
            return;
        }
        // Ignore if the user didn't click specifically in the "i" button
        if (event.target === event.currentTarget) {
            return;
        }
        apiRef.current.toggleDetailPanel(params.id);
    }, [
        apiRef,
        contentCache,
        props.getDetailPanelContent
    ]);
    var handleCellKeyDown = React.useCallback(function(params, event) {
        if (props.getDetailPanelContent == null) {
            return;
        }
        if (params.field === _gridDetailPanelToggleColDef.GRID_DETAIL_PANEL_TOGGLE_FIELD && event.key === ' ') {
            apiRef.current.toggleDetailPanel(params.id);
        }
    }, [
        apiRef,
        props.getDetailPanelContent
    ]);
    (0, _xDataGrid.useGridApiEventHandler)(apiRef, 'cellClick', handleCellClick);
    (0, _xDataGrid.useGridApiEventHandler)(apiRef, 'cellKeyDown', handleCellKeyDown);
    apiRef.current.registerControlState({
        stateId: 'detailPanels',
        propModel: props.detailPanelExpandedRowIds,
        propOnChange: props.onDetailPanelExpandedRowIdsChange,
        stateSelector: _gridDetailPanelSelector.gridDetailPanelExpandedRowIdsSelector,
        changeEvent: 'detailPanelsExpandedRowIdsChange'
    });
    var toggleDetailPanel = React.useCallback(function(id) {
        if (props.getDetailPanelContent == null) {
            return;
        }
        var content = contentCache[id];
        if (!/*#__PURE__*/ React.isValidElement(content)) {
            return;
        }
        var ids = apiRef.current.getExpandedDetailPanels();
        apiRef.current.setExpandedDetailPanels(ids.includes(id) ? ids.filter(function(rowId) {
            return rowId !== id;
        }) : _to_consumable_array(ids).concat([
            id
        ]));
    }, [
        apiRef,
        contentCache,
        props.getDetailPanelContent
    ]);
    var getExpandedDetailPanels = React.useCallback(function() {
        return (0, _gridDetailPanelSelector.gridDetailPanelExpandedRowIdsSelector)(apiRef.current.state);
    }, [
        apiRef
    ]);
    var setExpandedDetailPanels = React.useCallback(function(ids) {
        apiRef.current.setState(function(state) {
            return (0, _extends2.default)({}, state, {
                detailPanel: (0, _extends2.default)({}, state.detailPanel, {
                    expandedRowIds: ids
                })
            });
        });
        apiRef.current.requestPipeProcessorsApplication('rowHeight');
    }, [
        apiRef
    ]);
    var storeDetailPanelHeight = React.useCallback(function(id, height) {
        var heightCache = (0, _gridDetailPanelSelector.gridDetailPanelRawHeightCacheSelector)(apiRef.current.state);
        if (!heightCache[id] || heightCache[id].height === height) {
            return;
        }
        apiRef.current.setState(function(state) {
            return (0, _extends2.default)({}, state, {
                detailPanel: (0, _extends2.default)({}, state.detailPanel, {
                    heightCache: (0, _extends2.default)({}, heightCache, _define_property({}, id, (0, _extends2.default)({}, heightCache[id], {
                        height: height
                    })))
                })
            });
        });
        apiRef.current.requestPipeProcessorsApplication('rowHeight');
    }, [
        apiRef
    ]);
    var detailPanelHasAutoHeight = React.useCallback(function(id) {
        var heightCache = (0, _gridDetailPanelSelector.gridDetailPanelRawHeightCacheSelector)(apiRef.current.state);
        return heightCache[id] ? heightCache[id].autoHeight : false;
    }, [
        apiRef
    ]);
    var detailPanelPubicApi = {
        toggleDetailPanel: toggleDetailPanel,
        getExpandedDetailPanels: getExpandedDetailPanels,
        setExpandedDetailPanels: setExpandedDetailPanels
    };
    var detailPanelPrivateApi = {
        storeDetailPanelHeight: storeDetailPanelHeight,
        detailPanelHasAutoHeight: detailPanelHasAutoHeight
    };
    (0, _xDataGrid.useGridApiMethod)(apiRef, detailPanelPubicApi, 'public');
    (0, _xDataGrid.useGridApiMethod)(apiRef, detailPanelPrivateApi, 'private');
    React.useEffect(function() {
        if (props.detailPanelExpandedRowIds) {
            var currentModel = (0, _gridDetailPanelSelector.gridDetailPanelExpandedRowIdsSelector)(apiRef.current.state);
            if (currentModel !== props.detailPanelExpandedRowIds) {
                apiRef.current.setExpandedDetailPanels(props.detailPanelExpandedRowIds);
            }
        }
    }, [
        apiRef,
        props.detailPanelExpandedRowIds
    ]);
    var updateCachesAndForceUpdate = React.useCallback(function() {
        if (!props.getDetailPanelContent) {
            return;
        }
        apiRef.current.setState(function(state) {
            return (0, _extends2.default)({}, state, {
                detailPanel: (0, _extends2.default)({}, state.detailPanel, cacheContentAndHeight(apiRef, props.getDetailPanelContent, props.getDetailPanelHeight, state.detailPanel.heightCache))
            });
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        props.getDetailPanelContent,
        props.getDetailPanelHeight
    ]);
    (0, _xDataGrid.useGridApiEventHandler)(apiRef, 'sortedRowsSet', updateCachesAndForceUpdate);
    var previousGetDetailPanelContentProp = React.useRef(undefined);
    var previousGetDetailPanelHeightProp = React.useRef(undefined);
    var updateCachesIfNeeded = React.useCallback(function() {
        if (props.getDetailPanelContent === previousGetDetailPanelContentProp.current && props.getDetailPanelHeight === previousGetDetailPanelHeightProp.current) {
            return;
        }
        apiRef.current.setState(function(state) {
            return (0, _extends2.default)({}, state, {
                detailPanel: (0, _extends2.default)({}, state.detailPanel, cacheContentAndHeight(apiRef, props.getDetailPanelContent, props.getDetailPanelHeight, state.detailPanel.heightCache))
            });
        });
        previousGetDetailPanelContentProp.current = props.getDetailPanelContent;
        previousGetDetailPanelHeightProp.current = props.getDetailPanelHeight;
    }, [
        apiRef,
        props.getDetailPanelContent,
        props.getDetailPanelHeight
    ]);
    var addDetailHeight = React.useCallback(function(initialValue, row) {
        var expandedRowIds = (0, _gridDetailPanelSelector.gridDetailPanelExpandedRowIdsSelector)(apiRef.current.state);
        if (!expandedRowIds || expandedRowIds.length === 0 || !expandedRowIds.includes(row.id)) {
            initialValue.detail = 0;
            return initialValue;
        }
        updateCachesIfNeeded();
        var heightCache = (0, _gridDetailPanelSelector.gridDetailPanelExpandedRowsHeightCacheSelector)(apiRef);
        var _heightCache_row_id;
        initialValue.detail = (_heightCache_row_id = heightCache[row.id]) !== null && _heightCache_row_id !== void 0 ? _heightCache_row_id : 0; // Fallback to zero because the cache might not be ready yet (for example page was changed)
        return initialValue;
    }, [
        apiRef,
        updateCachesIfNeeded
    ]);
    var enabled = props.getDetailPanelContent !== undefined;
    (0, _internals.useGridRegisterPipeProcessor)(apiRef, 'rowHeight', addDetailHeight, enabled);
    var isFirstRender = React.useRef(true);
    if (isFirstRender.current) {
        updateCachesIfNeeded();
    }
    React.useEffect(function() {
        if (!isFirstRender.current) {
            updateCachesIfNeeded();
        }
        isFirstRender.current = false;
    }, [
        apiRef,
        updateCachesIfNeeded
    ]);
};
exports.useGridDetailPanel = useGridDetailPanel;
